var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-image"},[_c('label',{staticClass:"file-image__btn"},[_vm._v("Upload File"),_c('input',{attrs:{"type":"file","id":_vm.id,"name":_vm.name,"accept":"image/*"},on:{"change":_vm.fileChange}})])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }